export default __webpack_public_path__ + "static/media/jakcson.03704bcb.png";